import React from 'react';
import { reduxForm } from 'redux-form';
// import topLogo1 from '@assets/img/illustrations/logocover.png';
import { Formik, Field, Form } from 'formik';
import cn from 'classnames';
import EN from '@localization/EN';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import topLogo from '@assets/img/illustrations/client_logo.png';
import topLogoAmp from '@assets/img/illustrations/wrablerLogo.png';
import { getSubdomain } from '@helpers/Utility';
import styles from './index.module.css';

const LoginNewUN = (props) => {
  const subDomain = getSubdomain();
  const handleLinkClick = (e, path) => {
    if (props.loginLoading) {
      e.preventDefault();
    } else {
      props.navigate(path);
    }
  };
  return (
    <div className={cn('w-100', styles.loginbodywhole)}>
      {subDomain === 'untest' || subDomain === 'amp'
        ? (
          <div className={cn('container', styles.loginbody)}>
            <div className="row align-items-center justify-content-center p-xl-6">
              <div className="col-12 col-md-6 offset-xl-2 offset-md-1 order-md-2 mb-5 mb-md-2">
                <img width="100%" src={topLogoAmp} alt="..." />
              </div>
              <div className="col-12 col-md-5 col-xl-4 order-md-1 my-5">
                <div className={cn('card', styles.cardLogin)}>
                  <div className={cn('col-md-12 p-5')}>
                    <div className={cn(styles.headerBox)}>
                      <h1 className={cn(styles.heading)}>
                        Sign in
                      </h1>
                    </div>
                    <div className={cn(styles.form, props && props.errmsg ? 'pt-0' : 'pt-5')}>
                      <Formik
                        initialValues={{
                          userName: '',
                          password: ''
                        }}
                        validationSchema={Yup.object().shape({
                          userName: Yup.string().email(subDomain === 'stageun' || subDomain === 'amp' ? 'Users only with @kanari.ai or @un.org domains are accepted' : 'Invalid email address').required(EN.EMAIL_ADDRESS_REQUIRED).min(3, EN.MIN_LENGTH),
                          password: Yup.string().required(EN.PASS_VALIDATION)
                        })}
                        onSubmit={(values) => {
                          props.handleSubmit(values);
                        }}
                      >
                        {({ touched, errors, handleChange }) => (
                          <Form>
                            {/* {props && props.errmsg && (
                            <div className="alert alert-danger" style={{ textAlign: 'left', backgroundColor: 'red', color: 'white' }} role="alert">
                              <p>
                                {props.errorDescription}
                              </p>
                            </div>
                            ) } */}
                            <div className="form-group" style={{ textAlign: 'left' }}>
                              <label htmlFor="Username">
                                {EN.EMAIL_TEXT}
                              </label>
                              <Field
                                type="Text"
                                name="userName"
                                onChange={handleChange('userName')}
                                onFocus={props.resetMsg}
                                placeholder="Enter your email"
                                className={cn(`form-control textBox ${
                                  errors.userName ? 'is-invalid' : ''
                                }`, styles.textBox)}
                              />
                              {touched.userName && errors.userName && (
                              <span className="error">
                                {errors.userName}
                              </span>
                              )}
                            </div>
                            <div className="form-group">
                              <div className="row">
                                <div className="col-6" style={{ textAlign: 'left' }}>
                                  <label htmlFor="Password">
                                    {EN.Password}
                                  </label>
                                </div>
                              </div>

                              <div className="input-group input-group-merge">
                                <input
                                  type={props.showText ? 'text' : 'password'}
                                  name="password"
                                  onChange={handleChange('password')}
                                  onFocus={props.resetMsg}
                                  placeholder="Enter your password"
                                  className={cn(`form-control border-right-0 form-control-appended ${
                                    errors.password ? 'is-invalid' : ''
                                  }`, styles.textBox)}
                                />
                                <div className="input-group-append">
                                  <span className={cn('input-group-text', styles.icon)}>

                                    <i className="fe fe-eye cursor-pointer" onClick={() => { props.ontoggleClickLock(); }} role="presentation" />
                                  </span>
                                </div>
                              </div>
                              {touched.password && errors.password && (
                              <span className="error">
                                {errors.password}
                              </span>
                              )}
                              <div className={cn(styles.forgotPassword, 'row pl-3')}>
                                <Link className="form-text" to="/forgotpassword" onClick={e => handleLinkClick(e, '/forgotpassword')}>
                                  <u>
                                Forgot password?
                                  </u>
                                </Link>
                              </div>
                            </div>
                            {props && props.errmsg && props.errorDescription === EN.LoginInactiveUserErrorMsg ? (
                              <button className={cn(styles.resendLinkButton, 'form-text')} onClick={props.resendVerify} disabled={props.disabledResendLink} type="button">
                                <u>
                                  {EN.VERIFY_LINK_RESEND}
                                </u>
                              </button>
                            )
                              : null}
                            {props.disabledResendLink ? (
                              <span>
                                {EN.VERIFY_LINK_SENT_TEXT}
                              </span>
                            )
                              : null}
                            <div className="text-right">
                              <button
                                type="submit"
                                className={cn(styles.submitButton)}
                              >
                            Sign in
                              </button>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </div>
                    <div className="text-left">
                      <p className="mb-5">
                      Don&apos;t have an account yet?
                        <a href="/users/signup" className="pl-1" onClick={e => handleLinkClick(e, '/users/signup')}>
                          <u>
                            {EN.Signup}
                          </u>
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className={cn('container', styles.loginbody)}>
            <div className="row align-items-center justify-content-center p-xl-6 pt-imini-6 pt-iair-6">
              {/* <div className="col-12 col-md-6 offset-xl-2 offset-md-1 order-md-2 mb-5 mb-md-2">
                <div className={cn('col-12 col-lg-12 col-xl-12 text-center justify-content-center py-2 ml-lg-3 ml-xl-4')}>
                  <img className={cn('img-fluid', styles.formLogo)} src={topLogo} alt="..." />
                </div>
                <br />
                <div className={cn('col-12 col-lg-10 col-xl-8 text-center justify-content-center py-2 ml-lg-3 ml-xl-4')}>
                  <svg className={cn('img-fluid', styles.ampLogo)} viewBox="0 0 316 106" height="10%" width="40%" style={{ marginLeft: '50%' }} fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M296.5 8.3C290.5 4.8 283.5 3.3 274.9 3.3H250.6C248.3 3 246.3 4.3 245.6 6.3L217.3 76.8L189.3 3.3C188.5 1.5 186.8 0.3 184.8 0C182.8 0 181 1 180 2.8L158.4 47.1L137.4 2.8C136.4 1 134.6 0 132.6 0C130.6 0 128.8 1.3 128.1 3.3L99 78.8L59.2 3.3C58.4 1.5 56.7 0.5 54.7 0.5C52.9 0.5 51.2 1.5 50.2 3.3L0.6 96.4C-0.2 97.9 -0.2 99.9 0.6 101.4C1.4 102.9 3.1 103.9 4.9 103.9H26.5C28.5 103.9 30 102.9 31 101.1L36.5 90H72.3L78.1 101.1C78.9 102.9 80.6 103.9 82.6 103.9H117.4C119.4 103.9 121.4 102.6 122.2 100.6L135.6 65L153.9 103.3C154.7 105.1 156.4 106.1 158.4 106.1C160.4 106.1 162.2 105.1 162.9 103.3L181.2 64.5L194.5 100.3C195.3 102.3 197 103.6 199.3 103.6H234.9C236.9 103.6 238.9 102.3 239.7 100.3L248.2 77.4H274.8C283.3 77.4 290.6 75.9 296.9 72.6C303.2 69.3 307.9 64.8 311.2 59.5C314.5 54 316 47.4 316 40.6C316.3 33.6 314.5 27.3 311.2 22C307.8 16.1 303 11.6 296.5 8.3ZM66.7 67.5C66.4 67.7 65.9 68 65.7 68H42.9C42.4 68 42.1 67.8 41.9 67.5C41.6 67.3 41.6 66.8 41.9 66.3L53.4 44.2C53.9 43.5 55.2 43.5 55.7 44.2L67.2 66.3C67 66.8 67 67 66.7 67.5ZM284.1 33.1L272.6 55.2C272.1 55.9 270.8 55.9 270.3 55.2L258.8 33.1C259.1 32.6 259.1 32.4 259.3 31.9C259.6 31.7 260.1 31.4 260.3 31.4H283.1C283.6 31.4 283.9 31.6 284.1 31.9C284.3 32.1 284.3 32.6 284.1 33.1Z" fill="white" />
                  </svg>
                </div>

              </div> */}
              <div className="col-12 col-md-5 col-xl-4 order-md-1 my-5">
                <div className={cn('card', styles.cardLogin)}>
                  <div className={cn('col-md-12 p-5')}>
                    <div className={styles.cardLogo}>
                      <img src={topLogo} alt="..." className={cn('img-fluid', styles.cardLogoWidth)} />
                    </div>
                    <div className={cn(styles.headerBox)}>
                      <h1 className={cn(styles.heading)}>
                      Sign in
                      </h1>
                    </div>
                    <div className={cn(styles.form, props && props.errmsg ? 'pt-0' : 'pt-5')}>
                      <Formik
                        initialValues={{
                          userName: '',
                          password: ''
                        }}
                        validationSchema={Yup.object().shape({
                          userName: Yup.string().email(subDomain === 'stageun' || subDomain === 'amp' ? 'Users only with @kanari.ai or @un.org domains are accepted' : 'Invalid email address').required(EN.EMAIL_ADDRESS_REQUIRED).min(3, EN.MIN_LENGTH),
                          password: Yup.string().required(EN.PASS_VALIDATION)
                        })}
                        onSubmit={(values) => {
                          props.handleSubmit(values);
                        }}
                      >
                        {({ touched, errors, handleChange }) => (
                          <Form>
                            {/* {props && props.errmsg && (
                            <div className="alert alert-danger" style={{ textAlign: 'left', backgroundColor: 'red', color: 'white' }} role="alert">
                              <p>
                                {props.errorDescription}
                              </p>
                            </div>
                            ) } */}
                            <div className="form-group" style={{ textAlign: 'left' }}>
                              <label htmlFor="Username">
                                {EN.EMAIL_TEXT}
                              </label>
                              <Field
                                type="Text"
                                name="userName"
                                onChange={handleChange('userName')}
                                onFocus={props.resetMsg}
                                placeholder="Enter your email"
                                className={cn(`form-control textBox ${
                                  errors.userName ? 'is-invalid' : ''
                                }`, styles.textBox)}
                              />
                              {touched.userName && errors.userName && (
                              <span className="error">
                                {errors.userName}
                              </span>
                              )}
                            </div>
                            <div className="form-group">
                              <div className="row">
                                <div className="col-6" style={{ textAlign: 'left' }}>
                                  <label htmlFor="Password">
                                    {EN.Password}
                                  </label>
                                </div>
                              </div>

                              <div className="input-group input-group-merge">
                                <input
                                  type={props.showText ? 'text' : 'password'}
                                  name="password"
                                  onChange={handleChange('password')}
                                  onFocus={props.resetMsg}
                                  placeholder="Enter your password"
                                  className={cn(`form-control border-right-0 form-control-appended ${
                                    errors.password ? 'is-invalid' : ''
                                  }`, styles.textBox)}
                                />
                                <div className="input-group-append">
                                  <span className={cn('input-group-text', styles.icon)}>

                                    <i className="fe fe-eye cursor-pointer" onClick={() => { props.ontoggleClickLock(); }} role="presentation" />
                                  </span>
                                </div>
                              </div>
                              {touched.password && errors.password && (
                              <span className="error">
                                {errors.password}
                              </span>
                              )}
                              <div className={cn(styles.forgotPassword, 'row pl-3')}>
                                <Link className="form-text" to="/forgotpassword" onClick={e => handleLinkClick(e, '/forgotpassword')}>
                                  <u>
                              Forgot password?
                                  </u>
                                </Link>
                              </div>

                            </div>
                            {/* {(props && props.errmsg && props.errorDescription === EN.LoginInactiveUserErrorMsg) ? (
                            <>
                              <button className={cn(styles.resendLinkButton, 'form-text')} onClick={props.resendVerify} type="button">
                                <u>
                                  {EN.VERIFY_LINK_RESEND}
                                </u>
                              </button>
                            </>
                            )
                              : null}
                            {props.disabledResendLink ? (
                              <span>
                                {EN.VERIFY_LINK_SENT_TEXT}
                              </span>
                            )
                              : null} */}

                            <div className="text-right">
                              <button
                                type="submit"
                                className={cn(styles.submitButton)}
                                disabled={props.loginLoading}
                              >
                          Sign in
                              </button>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </div>
                    {/* <div className="text-left">
                      <p className="mb-1">
                    Don&apos;t have an account yet?
                        <a href="/users/signup" className="pl-1" onClick={e => handleLinkClick(e, '/users/signup')}>
                          <u>
                            {EN.Signup}
                          </u>
                        </a>
                      </p>
                    </div> */}
                    {/* <div className="text-left">
                      <p className="mb-5">
                      Didn&apos;t get your confirmation email?
                        <a href="/resend/email" className="pl-1" onClick={e => handleLinkClick(e, '/resend/email')}>
                          <u>
                          We can resend it.
                          </u>
                        </a>
                      </p>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
                          }
    </div>
  );
};

export default reduxForm({
  form: 'LoginPage', // a unique identifier for this form
})(LoginNewUN);
